import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";

import { BlockServiceAction, BlockServiceReasonAction, SalonAvailabilityDetailAction } from "../../../../redux/Action/Availability";
import CommanForm from "../../../../components/FormController/Commanform";
import {
    setDateFormatData,
    setTimeHelper,
    utcStoredToLocalDateAndTime,
    localFormToUtcDateAndTime,
} from "../../../../utils/Helper";
import { Config } from "../../../../config/Config";
import Errormessages from "../../../../components/ErrorMessage/Errormessages";
import BlockServiceValidaiton from "../../../../yup/BlockService/BlockService";
import Spinner from "../../../../components/Spinner";
import Button from "../../../../components/Ui/Button";
import BlockServiceValidate from "../../../../yup/BlockService/BlockServiceValidate";
import moment from "moment";
import { FormattedMessage } from "react-intl";

const BlockService = () => {
    const dispatch = useDispatch<any>()
    const local_language = localStorage.getItem('lang')

    const block_service_close_reason = useSelector((state: any) => state.BlockServiceReasonState);
    const salon_detail = useSelector((state: any) => state.SalonAvailabilityState);
    const add_block_service = useSelector((state: any) => state.BlockServiceState);
    const profile_data = useSelector((state: any) => state.GetProfileState);


    const [status, setStatus]: any = useState(false)
    const [disableData, setDisableData] = useState(status == 1 ? true : false);


    const handleBlockServiceToggle = (e: any) => {
        setStatus(e?.target?.checked)
    }
    const schema = status === false ? BlockServiceValidaiton : BlockServiceValidate;


    const { register, watch, setValue, handleSubmit, errors, setError, reset ,getValues} = CommanForm({
        validationSchema: schema,
        defaultValues: {
            start_date: "", end_date: "",
            start_time: null,
            end_time: null,
            unavailability: "",
            close_services: "",
            reason_val: ""
        }
    });


    useEffect(() => {
        dispatch(BlockServiceReasonAction({ attrib_type: 1 }))
    }, []);

    const [textareaError, setTextAreaError] = useState("")

    useEffect(() => {
        if (status == 0 && watch("close_services") && !watch("reason_val")) {
            // return setTextAreaError("Reason is required")
            return setTextAreaError(local_language == "alb" ? "Kërkohet arsye" : "Reason is required")

        }
        else {
            setTextAreaError("")
        }
    }, [watch("close_services"), textareaError, watch("reason_val")])



    const [startDateError, setStartDateError] = useState("")
    const [startTimeError, setStartTimeError] = useState("")

    useEffect(() => {
        if (status == 0) {
            if (watch("start_time") || watch("end_time")) {
                setStartTimeError("")
            }

        }
    }, [watch("start_time"), watch("end_time")]);


//     useEffect(() => {
//         if (status == false) {
//             if (watch("start_time") || watch("end_time")) {
//                 // setValue("start_date", salon_detail?.data?.data?.block_Service_data?.start_date ? moment(salon_detail?.data?.data?.block_Service_data?.start_date).format("YYYY/MM/DD") : "")
//                 setValue("end_date", "")
//             }
//         }

//     }, [status])



    const onsubmit = (payload: any) => {
        if (status == 0 && watch("close_services") && !watch("reason_val")) {
            // return setTextAreaError("Reason is required")
            return setTextAreaError(local_language == "alb" ? "Kërkohet arsye" : "Reason is required")

        }
        else {
            setTextAreaError("")
        }

        if (status == 0) {

            setError('start_time', { type: '', message: '' });
            setError('end_time', { type: '', message: '' });
            setError('end_date', { type: '', message: '' });

            if (watch('start_time') && watch('end_time')) {
                if (!watch("end_date")) {
                    return setError('end_date', { type: 'end_date', message: local_language == "alb" ? 'Kërkohet koha e përfundimit' : 'End time is required' });
                }
            }
            else if (watch('start_time') && !watch('end_time')) {
                return setError('end_time', { type: 'end_time', message: local_language == "alb" ? 'Kërkohet koha e përfundimit' : 'End time is required' });
            }
            else if (!watch('start_time') && watch('end_time')) {
                return setError('start_time', { type: 'start_time', message: local_language == "alb" ? 'Kërkohet data e fillimit' : 'Start time is required' });
            }
            else {
                if (watch("start_date") || watch("end_date")) {
                    if (!watch("start_date")) {
                        return setError('start_date', { type: 'start_date', message: local_language == "alb" ? 'Kërkohet data e fillimit' : 'Start time is required' });
                    }
                    if (!watch("end_date")) {
                        return setError('end_date', { type: 'end_date', message: local_language == "alb" ? 'Kërkohet koha e përfundimit' : 'End time is required' });
                    }
                }
            }

        }

        if (status == 0) {
            let start_date = payload?.start_date ? moment(payload?.start_date).format("YYYY-MM-DD") : null;
            let end_date = payload?.end_date ? moment(payload?.end_date).format("YYYY-MM-DD") : null;
            let start_time = watch("start_time") ? moment(watch("start_time")).format("HH:mm") : null;
            let end_time = watch("end_time") ? moment(watch("end_time")).format("HH:mm") : null;

            if (watch("start_time") && watch("end_time")) {
                const startUtc = localFormToUtcDateAndTime(payload?.start_date, watch("start_time"));
                const endUtc = localFormToUtcDateAndTime(payload?.end_date, watch("end_time"));
                if (startUtc) {
                    start_date = startUtc.date;
                    start_time = startUtc.time;
                }
                if (endUtc) {
                    end_date = endUtc.date;
                    end_time = endUtc.time;
                }
            }

            const data = {
                start_date,
                end_date,
                start_time,
                end_time,
                unavailability: payload?.Unavailability ? payload?.Unavailability : "",
                close_services: payload?.close_services, reason: watch("reason_val"),
                salon_id: Config?.USER_DETAILS?.id,
                is_block_service: 0,

            }


            if (status == 0 && watch("close_services") && watch("reason_val")?.length == 0) {
                return setTextAreaError(local_language == "alb" ? "Kërkohet arsye" : "Reason is required")
            }
            else {
                setTextAreaError("")
            }

            dispatch(BlockServiceAction(data))

        }
        else {
            const data = {
                is_block_service: 1,
                salon_id: Config?.USER_DETAILS?.id
            }

            dispatch(BlockServiceAction(data))

        }
    }

    useEffect(() => {
        if (salon_detail?.status || salon_detail?.data?.data) {
            const block = salon_detail?.data?.data?.block_Service_data;
            const apiStartDate = block?.start_date;
            const apiEndDate = block?.end_date;
            const originalStartTime = block?.start_time ? String(block.start_time) : "";
            const originalEndTime = block?.end_time ? String(block.end_time) : "";

            const startLocalPair =
                apiStartDate && originalStartTime
                    ? utcStoredToLocalDateAndTime(String(apiStartDate), originalStartTime)
                    : null;
            const endLocalPair =
                apiEndDate && originalEndTime
                    ? utcStoredToLocalDateAndTime(String(apiEndDate), originalEndTime)
                    : null;

            const useUtcHydration = Boolean(startLocalPair && endLocalPair);

            if (useUtcHydration) {
                setValue("start_date", startLocalPair!.dateStr);
                setValue("end_date", endLocalPair!.dateStr);
                setValue("start_time", startLocalPair!.timeDate);
                setValue("end_time", endLocalPair!.timeDate);
            } else {
                setValue("start_date", apiStartDate ? moment(apiStartDate).format("YYYY/MM/DD") : "");
                setValue("end_date", apiEndDate ? moment(apiEndDate).format("YYYY/MM/DD") : "");

                const targetStartDate = moment().toDate();
                const [startHours, startMinutes, startSeconds] = originalStartTime.split(":");
                targetStartDate.setHours(Number(startHours));
                targetStartDate.setMinutes(Number(startMinutes));
                targetStartDate.setSeconds(Number(startSeconds));
                const formattedStartDate = targetStartDate.toString();

                const targetEndDate = moment().toDate();
                const [endHours, endMinutes, endSeconds] = originalEndTime.split(":");
                targetEndDate.setHours(Number(endHours));
                targetEndDate.setMinutes(Number(endMinutes));
                targetEndDate.setSeconds(Number(endSeconds));
                const formattedEndDate = targetEndDate.toString();

                if (
                    formattedStartDate?.length > 0 &&
                    formattedStartDate !== "Invalid Date" &&
                    formattedEndDate?.length > 0 &&
                    formattedEndDate !== "Invalid Date"
                ) {
                    setValue("start_time", formattedStartDate ? moment(formattedStartDate).toDate() : "");
                    setValue("end_time", formattedEndDate ? moment(formattedEndDate).toDate() : "");
                }
            }

            setValue("Unavailability", block?.unavailability ? block.unavailability : "");
            setValue("close_services", block?.close_services ? block.close_services : "");
            setValue("reason_val", block?.reason);
            setValue("status", block?.status);

            setStatus(block?.block_details?.is_block_service == 0 ? false : true);
        }
    }, [salon_detail])


    useEffect(() => {
        if (status == true) {
            reset()
            // dispatch(SalonAvailabilityDetailAction({ detail_id: profile_data?.data?.data?.id }))
        }
    }, [add_block_service])

    useEffect(() => {
        return () => {
            dispatch(SalonAvailabilityDetailAction("RESET"))
            dispatch(BlockServiceAction("RESET"))
            dispatch(BlockServiceReasonAction("RESET"))
            setValue("start_time", null)

        }
    }, [])


    return (
        <>
            {/*  ********************** Block Service Data ********************** */}
            <div className='BlockServiceDate mt-5'>
                {salon_detail?.loading || add_block_service?.loading ? <Spinner /> : ""}

                <h6><FormattedMessage id="block_service_dates" /></h6>
                <form onSubmit={handleSubmit(onsubmit)}>
                    <div className="form-check form-switch float-end" >
                        <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                            onChange={(e: any) => handleBlockServiceToggle(e)}
                            checked={status}
                        />
                    </div>

                    <p><b><FormattedMessage id="select_date_range" /></b></p>
                    <div className='row gy-3 align-items-start'>

                        <div className="col-md-3 normalINput">
                            <label className="form-label f-16 fw-500 d-block"><FormattedMessage id="from" />
                            </label>
                            <DatePicker
                                selected={watch("start_date")}
                                className='form-control'
                                placeholderText="YYYY/MM/DD"
                                timeFormat="MM DD YYYY"
                                onKeyDown={(e: any) => e.preventDefault()}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={50}
                                 minDate={new Date()}
                                showIcon
                                value={watch("start_date")}
                                disabled={status == 1}
                                onChange={(start_date: any) => {
                                    setDisableData(false);
                                    setValue('start_date', setDateFormatData(start_date))
                                    setValue('end_date', '')
                                }}
                            />
                        </div>
                        {status == 0 && <Errormessages name="start_date" errors={errors} />}



                        <div className="col-md-3 normalINput">
                            <label className="form-label f-16 fw-500 d-block"><FormattedMessage id="to" />
                            </label>
                            <DatePicker
                                selected={(watch('end_date'))}
                                value={watch("end_date") != null ? watch("end_date") : moment(salon_detail?.data?.data?.block_Service_data?.end_date).format("YYYY/MM/DD")}
                                className="form-control"
                                placeholderText="YYYY/MM/DD"
                                timeFormat="MM DD YYYY"
                                onKeyDown={(e: any) => e.preventDefault()}
                                showYearDropdown
                                scrollableYearDropdown
                                //  minDate={new Date()}
                                yearDropdownItemNumber={50}
                                showIcon
                                disabled={disableData || status == 1}
                                minDate={watch('start_date')}
                                toggleCalendarOnIconClick
                                onChange={(end_date: any) => {
                                    setValue('end_date', setDateFormatData(end_date))
                                }}
                            />
                            {status == 0 && <Errormessages name="end_date" errors={errors} />}

                        </div>

                        <div className="col-md-6 normalINput">
                            <label className='form-label'><FormattedMessage id="unavailability" />
                                <span>*</span></label>
                            <select className="form-select" disabled={status == 1}
                                {...register("Unavailability")}
                            >
                                <option value=""><FormattedMessage id="select_reason" /></option>
                                <option value="1"><FormattedMessage id="fully_occupied" /></option>
                                <option value="2"><FormattedMessage id="not_available" /></option>
                            </select>
                            {status == 0 && <Errormessages name="Unavailability" errors={errors} />}

                        </div>
                    </div>
                    <p><b><FormattedMessage id="select_time_range" /></b></p>
                    <div className='row gy-3 align-items-start'>
                        <div className="col-md-3 normalINput">
                            <label className="form-label f-16 fw-500 d-block"><FormattedMessage id="from" /></label>
                            {/* <input type="time" className="form-control" disabled={status == 1} /> */}

                            <DatePicker
                                className="form-control"
                                selected={watch("start_time")}
                                onChange={(date: any) => {
                                    setValue("start_time", date)
                                    setTimeHelper({ time: date })
                                }}
                                value={watch("start_time")}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={5}
                                timeCaption="Time"
                                dateFormat="HH:mm"
                                disabled={status == 1}
                                timeFormat="HH:mm"
                                placeholderText="00:00"
                            />
                            {status == 0 && <Errormessages name="start_time" errors={errors} />}

                        </div>
                        <div className="col-md-3 normalINput">
                            <label className="form-label f-16 fw-500 d-block"><FormattedMessage id="to" /></label>
                            <DatePicker
                                className="form-control"
                                selected={watch("end_time")}
                                onChange={(date: any) => {
                                    setValue("end_time", date)
                                }}
                                value={watch("end_time")}

                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={5}
                                timeCaption="Time"
                                dateFormat="HH:mm"
                                timeFormat="HH:mm"
                                disabled={status == 1}

                                // minTime={getTimeHelper({ time: watch("start_time") })as any}
                                // maxTime={"00:00" as any}
                                placeholderText="00:00"

                            />
                            {status == 0 && <Errormessages name="end_time" errors={errors} />}

                        </div>
                        <div className="col-md-6 normalINput">
                            <label className='form-label'><FormattedMessage id="close_service" /><span>*</span></label>
                            <select className="form-select" disabled={status == 1} {...register("close_services")}>
                                <option value=""><FormattedMessage id="select_reason" /></option>
                                {
                                    block_service_close_reason?.data?.data?.map((item: any) => {
                                        return (
                                            <option key={item.id} value={item.id}>{item?.title}</option>
                                        )
                                    })
                                }

                            </select>
                            {status == 0 && <Errormessages name="close_services" errors={errors} />}

                            {watch("close_services") && <textarea className='form-select mt-2' placeholder='Enter Reason' {...register("reason_val")} disabled={status == 1}></textarea>}
                            {textareaError && <p className="text-danger"> {textareaError} </p>}
                        </div>
                    </div>
                    <Button text={<FormattedMessage id="submit" /> as any} type="submit" className="btn btn-fill mt-5 min-180" isLoading={salon_detail?.loading || add_block_service?.loading} />

                </form>

            </div>
        </>
    )
}

export default BlockService